/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

// decorators.js
import {createDecorator, VueDecorator} from 'vue-class-component';
import metaInfo from '@/decorators/Meta';

export const Meta: VueDecorator = createDecorator(metaInfo);
